module.exports = __webpack_public_path__ + "static/media/022-calculator.8f590a25.svg";